import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAiIconService } from '@vendasta/galaxy/ai-icon';

@Component({
  selector: 'inbox-draft-ready-badge',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './inbox-draft-ready-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './inbox-draft-ready-badge.component.scss',
})
export class InboxDraftReadyBadgeComponent {
  aiIconService = inject(GalaxyAiIconService);
}
